/* Durnev — move NEW-tagged product cards to the start of the
   collection grid, in the DOM.

   Why DOM and not CSS `order`? Card dividers between columns rely on
   `:nth-child(3n)` to skip the right edge of every row. If we use
   `order: -1` to push NEW cards visually, the :nth-child rule keeps
   matching the original DOM positions, so dividers end up in the
   wrong columns. Moving the cards in the actual DOM keeps both the
   visual order and the structural selectors in sync.

   Runs once on initial load only. We deliberately do NOT react to
   durnev-coll-infinite.js appending later pages: if a NEW-tagged card
   arrives in a later batch and we yank it to the front, it jumps
   out of the user's viewport mid-scroll — the user sees it briefly,
   then it's gone, reading as "the product skipped past me".

   Idempotent: bails out early if NEW cards are already at the front. */
(function () {
  function hasNewBadge(card) {
    return !!card.querySelector('.durnev-coll-card__badge--new');
  }

  function alreadySorted(cards) {
    var seenNonNew = false;
    for (var i = 0; i < cards.length; i++) {
      if (hasNewBadge(cards[i])) {
        if (seenNonNew) return false; // NEW found after a non-NEW → not sorted
      } else {
        seenNonNew = true;
      }
    }
    return true;
  }

  function reorder(grid) {
    var cards = Array.prototype.slice.call(grid.children).filter(function (c) {
      return c.classList && c.classList.contains('durnev-coll-card');
    });
    if (cards.length === 0 || alreadySorted(cards)) return;

    var newCards = cards.filter(hasNewBadge);
    if (newCards.length === 0) return;

    // Pause observer while we mutate, otherwise we get a re-entry loop.
    if (grid._newFirstObserver) grid._newFirstObserver.disconnect();

    // insertBefore in reverse preserves the relative order of new cards.
    for (var i = newCards.length - 1; i >= 0; i--) {
      grid.insertBefore(newCards[i], grid.firstChild);
    }

    if (grid._newFirstObserver) {
      grid._newFirstObserver.observe(grid, { childList: true });
    }
  }

  function init(grid) {
    reorder(grid);
    // Intentionally no MutationObserver — see file header for why.
  }

  function start() {
    document.querySelectorAll('.durnev-coll-grid').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
